import React from 'react';

export default function HowItWorks() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-12">
      <h3 className="text-xl font-semibold mb-2">How community governance works</h3>
      <p className="text-muted-foreground">Infographic and explanation content goes here.</p>
    </section>
  );
}
